import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; 

  const firebaseConfig = {
    apiKey: "AIzaSyBTwDtGXcbvNE5lIu-CKytDAdFomnEXI2M",
    authDomain: "sprout-1e19b.firebaseapp.com",
    databaseURL: "https://sprout-1e19b-default-rtdb.firebaseio.com",
    projectId: "sprout-1e19b",
    storageBucket: "sprout-1e19b.firebasestorage.app",
    messagingSenderId: "494546103084",
    appId: "1:494546103084:web:50ab10208bd125ebb91a89",
    measurementId: "G-5C5P4GELPJ"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); 